export default {
	// The key format should be: 'locale.filename'.
	'en.backoffice': require('../../lang/en/backoffice.php'),
	'es.backoffice': require('../../lang/es/backoffice.php'),
	'pt.backoffice': require('../../lang/pt/backoffice.php'),
	'en.auth': require('../../lang/en/auth.php'),
	'es.auth': require('../../lang/es/auth.php'),
	'pt.auth': require('../../lang/pt/auth.php'),
	//'en.frontoffice': require('../../lang/en/frontoffice.php'),
	//'es.frontoffice': require('../../lang/es/frontoffice.php'),
	//'pt.frontoffice': require('../../lang/pt/frontoffice.php'),
	'en.pagination': require('../../lang/en/pagination.php'),
	'es.pagination': require('../../lang/es/pagination.php'),
	'pt.pagination': require('../../lang/pt/pagination.php'),
	'en.passwords': require('../../lang/en/passwords.php'),
	'es.passwords': require('../../lang/es/passwords.php'),
	'pt.passwords': require('../../lang/pt/passwords.php'),
	//'en.pos': require('../../lang/en/pos.php'),
	//'es.pos': require('../../lang/es/pos.php'),
	//'pt.pos': require('../../lang/pt/pos.php'),
	'en.validation': require('../../lang/en/validation.php'),
	'es.validation': require('../../lang/es/validation.php'),
	'pt.validation': require('../../lang/pt/validation.php'),
}